/* 🤖 this file was generated by svg-to-ts */
export const matIconMultilineChart: {
  name: 'multiline-chart';
  data: string;
} = {
  name: 'multiline-chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m22 6.92-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"/></svg>`
};
